<template>
  <message-search
    :add-and-filter-persmission="false"
    :default-role="user.profile.roleid"
    :download-file="downloadFile"
    :get-messages="getMessages"
  />
</template>

<script>
import { MessageSearch } from 'operations';
import { fetchResult } from '@/modules/operations/api';
import _generalService from '@/modules/app/api.js';
import { mapState } from 'vuex';
import { name as userModuleName } from '@/modules/user/store';

export default {
  name: 'MainMessageWrapper',
  components: { MessageSearch },
  computed: {
    ...mapState(userModuleName, ['user']),
  },
  methods: {
    getMessages(params) {
      return fetchResult(params);
    },
    downloadFile(documentId) {
      return _generalService.downloadDocumentByAttachmentId(documentId);
    },
  },
};
</script>
